// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"a92994d7","222":"eace2672","453":"3d240b3a","874":"47414c6b","937":"47b50e73","966":"f35af87a"}[chunkId] + ".chunk.js";
};